import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import { firebaseConfig } from './config';
import {useHistory} from 'react-router-dom';

export const signoutAction = () =>{
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const history = useHistory();
  history.push('/');

}

export {firebase};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const sendEmailVerification = firebase.auth();
export const firestore = firebase.firestore();
export const database = firebase.database();
export const storage = firebase.storage();

// export const provider = new firebase.auth.GoogleAuthProvider(); 

export const GoogleProvider = new firebase.auth.GoogleAuthProvider();

 GoogleProvider.setCustomParameters({ prompt: 'select_account' });

export const handleUserProfile = async ({ userAuth, additionalData }) => {
  if (!userAuth) return;
  const { uid } = userAuth;
  console.log("Creating firestore ref");

    // const userRef = firestore.collection("webUsers");

  const userRef = firestore.doc(`webUsers/${uid}`);

  const snapshot = await userRef.get();

  if (!snapshot.exists) {
    const { lName,
      fName,
      email,
      } = userAuth;
    const timestamp = new Date();


    try {
      await userRef.set({
        lName,
        fName,
        email,
        createdDate: timestamp,
        ...additionalData
      });
    } catch (err) {
      console.log(err);
    }
  }

  return userRef;
};

export const handleUserGoogleProfile = async ({ userAuth, additionalData }) => {
  if (!userAuth) return;
  const { uid } = userAuth;
  console.log("Creating firestore ref");

    // const userRef = firestore.collection("webUsers");

  const userRef = firestore.doc(`webUsers/${uid}`);

  const snapshot = await userRef.get();

  if (!snapshot.exists) {
    const { lName,
      fName,
      email,
      } = userAuth;
    const timestamp = new Date();


    try {
      await userRef.set({
        email,
        uid: uid,
        createdDate: timestamp,
        ...additionalData
      });
    } catch (err) {
      console.log(err);
    }
  }

  return userRef;
};

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(userAuth => {
      unsubscribe();
      resolve(userAuth);
    }, reject);
  })
}
